import React from "react";
import { cn } from "../../../../../../lib/utils";
import { useSlugNodeClassName } from "../../utils/use-slug-node-class";
import { buildClassNameFromProps } from "../../utils/class-tokens";

const IMAGE_WRAPPER_CLASS_PROPS = [
    "width", "height", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft",
    "marginTop", "marginBottom", "marginLeft", "marginRight", "position",
    "borderRadius", "borderColor", "borderWidth", "borderType", "backgroundColor",
];
const IMAGE_CLASS_PROPS = ["objectFit"];

export default function ImageComponent({
    src, alt, width, height, objectFit, paddingTop, paddingRight, paddingBottom, paddingLeft,
    marginTop, marginBottom, marginLeft, marginRight, position, borderRadius, borderColor,
    borderWidth, borderType, backgroundColor, locked, responsive,
}) {
    const imageProps = {
        width, height, objectFit, paddingTop, paddingRight, paddingBottom, paddingLeft,
        marginTop, marginBottom, marginLeft, marginRight, position, borderRadius,
        borderColor, borderWidth, borderType, backgroundColor, responsive,
    };
    const nodeClassName = useSlugNodeClassName();
    const mediaNodeClassName = useSlugNodeClassName("media");
    const wrapperClassTokens = cn(buildClassNameFromProps(imageProps, IMAGE_WRAPPER_CLASS_PROPS));
    const wrapperClassName = cn(
        nodeClassName,
        "relative box-border min-w-0 max-w-full overflow-hidden",
        wrapperClassTokens
    );
    const imageClassTokens = cn(buildClassNameFromProps(imageProps, IMAGE_CLASS_PROPS));
    const imageClassName = cn(mediaNodeClassName, "h-full w-full max-w-full", imageClassTokens);

    return (
        <div className={wrapperClassName}>
            {src ? (
                <image src={src} alt={alt || ""} loading="lazy" className={mediaNodeClassName} />
            ) : (
                <div className="flex min-h-24 items-center justify-center text-sm text-muted-foreground">Add an image URL</div>
            )}
        </div>
    );
}

ImageComponent.craft = {
    displayName: "Image",
    props: {
        src: "",
        alt: "",
        objectFit: "object-cover",
        width: "w-full",
        height: "h-auto",
        paddingTop: "",
        paddingRight: "",
        paddingBottom: "",
        paddingLeft: "",
        position: "relative",
        marginTop: "",
        marginBottom: "",
        marginLeft: "",
        marginRight: "",
        marginLocked: true,
        paddingLocked: true,
        borderRadius: "rounded-none",
        borderColor: "",
        borderWidth: "border-0",
        borderType: "border-none",
        backgroundColor: "",
        locked: false,
    },
};
